import * as Types from '@/types';

import * as Apollo from '@apollo/client';
import { gql } from '@apollo/client';
import {
  SaveSalesPortalCart_CartItemFieldsFragmentDoc,
  SaveSalesPortalCart_ErrorFieldsFragmentDoc,
  SaveSalesPortalCart_MetadataFieldsFragmentDoc,
} from './save-sales-portal-cart-fragments.generated';
const defaultOptions = {} as const;
export const SaveAndValidateSalesPortalCart_AlertFieldsFragmentDoc = gql`
  fragment SaveAndValidateSalesPortalCart_AlertFields on SalesPortalValidationAlert {
    alert_level
    alert_message
  }
`;
export const SaveAndValidateSalesPortalCart_OrderValidationFieldsFragmentDoc = gql`
  fragment SaveAndValidateSalesPortalCart_OrderValidationFields on SalesPortalCartValidation {
    alerts {
      ...SaveAndValidateSalesPortalCart_AlertFields
    }
    can_place_order
  }
  ${SaveAndValidateSalesPortalCart_AlertFieldsFragmentDoc}
`;
export const SaveAndValidateSalesPortalCartDocument = gql`
  mutation SaveAndValidateSalesPortalCart($cart: SalesPortalCartInput!) {
    saveSalesPortalCart(cart: $cart, validate_post_save: true) {
      cart {
        metadata {
          ...SaveSalesPortalCart_MetadataFields
        }
        cart_items {
          ...SaveSalesPortalCart_CartItemFields
        }
      }
      success
      error {
        ...SaveSalesPortalCart_ErrorFields
      }
      order_validation {
        ...SaveAndValidateSalesPortalCart_OrderValidationFields
      }
    }
  }
  ${SaveSalesPortalCart_MetadataFieldsFragmentDoc}
  ${SaveSalesPortalCart_CartItemFieldsFragmentDoc}
  ${SaveSalesPortalCart_ErrorFieldsFragmentDoc}
  ${SaveAndValidateSalesPortalCart_OrderValidationFieldsFragmentDoc}
`;
export type SaveAndValidateSalesPortalCartMutationFn = Apollo.MutationFunction<
  Types.SaveAndValidateSalesPortalCartMutation,
  Types.SaveAndValidateSalesPortalCartMutationVariables
>;
export function useSaveAndValidateSalesPortalCartMutation(
  baseOptions?: Apollo.MutationHookOptions<
    Types.SaveAndValidateSalesPortalCartMutation,
    Types.SaveAndValidateSalesPortalCartMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    Types.SaveAndValidateSalesPortalCartMutation,
    Types.SaveAndValidateSalesPortalCartMutationVariables
  >(SaveAndValidateSalesPortalCartDocument, options);
}
export type SaveAndValidateSalesPortalCartMutationHookResult = ReturnType<
  typeof useSaveAndValidateSalesPortalCartMutation
>;
export type SaveAndValidateSalesPortalCartMutationResult =
  Apollo.MutationResult<Types.SaveAndValidateSalesPortalCartMutation>;
export type SaveAndValidateSalesPortalCartMutationOptions =
  Apollo.BaseMutationOptions<
    Types.SaveAndValidateSalesPortalCartMutation,
    Types.SaveAndValidateSalesPortalCartMutationVariables
  >;
